const LangTransactionDetails = {
	"transactionDetails._title": ["MY TRANSACTION DETAILS", "ប្រតិបត្តិការ​លម្អិត​ខ្ញុំ"],
	"transactionDetails.headers.transactionId": [
		"TRANSACTION ID",
		"លេខ​សម្គាល់ប្រតិបត្តិការ​​",
	],
	"transactionDetails.headers.receiptId": ["RECEIPT ID", "លេខ​សម្គាល់​វិក្កយបត្រ"],
	"transactionDetails.headers.dateAndTime": ["DATE AND TIME", "កាល​បរិច្ឆេទ និង​ម៉ោង​"],
	"transactionDetails.headers.store": ["STORE", "សាខា"],
	"transactionDetails.headers.starsEarned": ["STARS EARNED", "ចំនួន​ផ្កាយ​ទទួល​បាន"],
	"transactionDetails.headers.bonusStars": ["BONUS STARS", "ចំនួន​ផ្កាយ​បន្ថែម"],
	"transactionDetails.headers.cardNo": ["CARD NUMBER", "លេខ​កាត"],
	"transactionDetails.headers.title": ["TITLE", "ចំណង​ជើង​"],
	"transactionDetails.headers.amount": ["AMOUNT", "ចំនួន​ទឹក​ប្រាក់"],
	"transactionDetails.headers.payment": ["PAYMENT", "ការ​ទូទាត់"],
	"transactionDetails.bottom.total": ["TOTAL", "សរុប"],
	"transactionDetails.bottom.discount": ["Discount", "បញ្ចុះ​តម្លៃ"],
	"transactionDetails.params._invalidReceiptNo": [
		"Oops! Something went wrong",
		"អូហ៍! ប្រព័ន្ធ​មិន​ដំណើរ​ការ",
	],
	"transactionDetails.type.SALES": [
		"Mobile Ordering & Payment Purchase",
		"ទិញ​នៅ​​តាម​សាខា​",
	],
	"transactionDetails.type.PLUS ADJUSTMENT": [
		"In Store Reload",
		"បញ្ចូល​ទឹក​ប្រាក់​នៅ​តាម​សាខា​",
	],
	"transactionDetails.type.TOP UP": ["Reload SVC Card", "បញ្ចូល​ទឹក​ប្រាក់​​ក្នុង​កាត"],
	"transactionDetails.type.MINUS ADJUSTMENT": [
		"MINUS ADJUSTMENT",
		"vi_MINUS ADJUSTMENT",
	],
	"transactionDetails.type.POINTS REDEMPTION": [
		"POINTS REDEMPTION",
		"vi_POINTS REDEMPTION",
	],
	"transactionDetails.type.REFUND SALES ITEMS": [
		"REFUND SALES ITEMS",
		"vi_REFUND SALES ITEMS",
	],
	"transactionDetails.type.POINTS REWARD FOR ITEM": [
		"POINTS REWARD FOR ITEM",
		"vi_POINTS REWARD FOR ITEM",
	],
	"transactionDetails.type.ITEM REDEMPTION": ["ITEM REDEMPTION", "vi_ITEM REDEMPTION"],
	"transactionDetails.type.VOUCHER REDEMPTION": [
		"Mobile Order Rewards Redemption",
		"ប្តូរ​រង្វាន់​",
	],
	"transactionDetails.type.redeemed": ["Redeemed", "បាន​ប្តូរ​រង្វាន់​​រួច​"],
	"transactionDetails.type.FUNDS TRANSFER": ["Funds Transfer", "ផ្ទេរ​ទឹក​ប្រាក់​"],
	"transactionDetails.paymentType.CARD": ["Starbucks Card", "កាត​ Starbucks"],
	"transactionDetails.paymentType.CREDIT": ["Credit Card", "កាត​ឥណទាន"],
	"transactionDetails.paymentType.CASH": ["Cash", "សាច់​ប្រាក់"],
}

export default LangTransactionDetails



// WEBPACK FOOTER //
// ./src/resources/pages/LangTransactionDetails.js